export default __webpack_public_path__ + "images/mask_upload-OLsKh.png";